import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Download, Share, SquarePlus, X, WifiOff, RefreshCw } from "lucide-react";
import { usePwa, install, dismissInstall, closeIosSheet, applyUpdate } from "../lib/pwa";

export function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (online) return null;
  return (
    <div className="offline-bar" role="status" data-testid="offline-banner">
      <WifiOff size={16} /> Du er offline – tjek din forbindelse
    </div>
  );
}

export function UpdatePrompt() {
  const { updateReady } = usePwa();
  const { pathname } = useLocation();
  if (!updateReady || pathname.startsWith("/o/")) return null;
  return (
    <div className="update-card" role="status" data-testid="update-prompt">
      <span>Ny version klar</span>
      <button className="btn primary small" onClick={applyUpdate} data-testid="update-apply-btn">
        <RefreshCw size={15} /> Opdater
      </button>
    </div>
  );
}

export function InstallButton() {
  const { canInstall, dismissed } = usePwa();
  if (!canInstall || dismissed) return null;
  return (
    <button className="install-btn" onClick={install} data-testid="install-app-header-btn">
      <Download size={15} /> Installer app
    </button>
  );
}

export function InstallBanner() {
  const { canInstall, dismissed } = usePwa();
  if (!canInstall || dismissed) return null;
  return (
    <div className="install-banner" data-testid="install-banner">
      <img src="/icons/icon-192.png" alt="" />
      <div className="ib-text">
        <b>Installer JaTak Pro</b>
        <span>Hurtig adgang til udlevering og ordrer fra hjemmeskærmen.</span>
      </div>
      <button className="btn primary small" onClick={install} data-testid="install-banner-btn">
        Installer app
      </button>
      <button className="ib-close" aria-label="Luk" onClick={dismissInstall} data-testid="install-banner-dismiss">
        <X size={18} />
      </button>
    </div>
  );
}

export function IosInstallSheet() {
  const { iosSheet } = usePwa();
  if (!iosSheet) return null;
  return (
    <>
      <div className="sheet-scrim" onClick={closeIosSheet} data-testid="ios-sheet-scrim" />
      <div className="sheet" role="dialog" aria-label="Installer app" data-testid="ios-install-sheet">
        <div className="grab" />
        <h2>Installer JaTak Pro på iPhone</h2>
        <ol className="ios-steps">
          <li>
            <Share size={20} /> Tryk på <b>Del</b> nederst i Safari
          </li>
          <li>
            <SquarePlus size={20} /> Vælg <b>Føj til hjemmeskærm</b>
          </li>
          <li>
            <span className="ios-n">3</span> Tryk <b>Tilføj</b> øverst til højre
          </li>
        </ol>
        <button className="btn primary" style={{ width: "100%" }} onClick={closeIosSheet} data-testid="ios-sheet-close">
          Forstået
        </button>
      </div>
    </>
  );
}
